var _toConsumableArray = require("/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _createForOfIteratorHelper = require("/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var _objectSpread = require("/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
var _asyncToGenerator = require("/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");
var _classCallCheck = require("/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/john/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var jwkToPem = require("jwk-to-pem");
var jws = require("jws");

/** Class representing a PhoenixApi client. */
var PhoenixApiClient = /*#__PURE__*/function () {
  "use strict";

  /**
   * Create a PhoenixApiClient.
   * @param {object} options - objects that updates class options
   */
  function PhoenixApiClient() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, PhoenixApiClient);
    this.user = null;
    this.token = null;
    this.uses_token = false;
    this._id_token = null;
    this._decoded_id_token = null;
    this.expiration_timeout = 0;
    this.options = {
      client_id: null,
      handle_rate_limit: true,
      handle_server_error: 3,
      scope: ["account-owner"],
      session_name: "phoenix-api-js-client-session",
      id_token_sign_out: false,
      decode_id_token: false,
      ignore_state: false,
      session_scope: "tab",
      oauth_api_url: 'https://oauth-api.phone.com',
      accounts_url: 'https://accounts.phone.com',
      phoenix_url: 'https://api.phone.com'
    };
    if (!["tab", "browser"].includes(options.session_scope)) options.session_scope = "tab";
    Object.assign(this.options, options);
    this.listeners = {
      "logging-out": null,
      "logged-out": null,
      "session-expired": null,
      "error": null
    };
    this.cache_keys = "".concat(this.options.session_name, "-cache-keys");
  }
  _createClass(PhoenixApiClient, [{
    key: "id_token",
    get: function get() {
      if (this._id_token) return this._id_token;
      if (this.user && this._getItem(this.id_token_cache_key)) {
        return this._getItem(this.id_token_cache_key);
      }
      return null;
    },
    set: function set(val) {
      this._id_token = val;
      val ? this._setItem(this.id_token_cache_key, val) : this._removeItem(this.id_token_cache_key);
    }
  }, {
    key: "decoded_id_token",
    get: function get() {
      if (this._decoded_id_token) return this._decoded_id_token;
      if (this.user && this._getItem(this.decoded_id_token_cache_key)) {
        return JSON.parse(this._getItem(this.decoded_id_token_cache_key));
      }
      return null;
    },
    set: function set(val) {
      this._decoded_id_token = val;
      val ? this._setItem(this.decoded_id_token_cache_key, JSON.stringify(val)) : this._removeItem(this.decoded_id_token_cache_key);
    }
  }, {
    key: "decoded_id_token_cache_key",
    get: function get() {
      return "".concat(this.id_token_cache_key, "-decoded");
    }
  }, {
    key: "id_token_cache_key",
    get: function get() {
      return "".concat(this.options.session_name, "-id-token");
    }

    /**
     * Initializes user
     * @return {Promise<boolean>}
     */
  }, {
    key: "init_user",
    value: function () {
      var _init_user = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var user;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              user = this._getItem(this.options.session_name);
              if (user) user = JSON.parse(user);
              _context.t0 = user;
              if (!_context.t0) {
                _context.next = 7;
                break;
              }
              _context.next = 6;
              return this.set_user(user);
            case 6:
              _context.t0 = _context.sent;
            case 7:
              if (_context.t0) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return this._oauth();
            case 10:
              return _context.abrupt("return", !!this.user);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init_user() {
        return _init_user.apply(this, arguments);
      }
      return init_user;
    }()
    /**
     * Checks if URI's hash contains access token
     * @return {boolean} - if token is found - true, else false
     */
  }, {
    key: "_oauth",
    value: function () {
      var _oauth2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var parse_query, hashObject;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.user) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", true);
            case 2:
              parse_query = function parse_query(hash_string) {
                var hash = hash_string.substr(1).split("&").filter(function (v) {
                  return !!v.length;
                }).map(function (v) {
                  return v.split("=");
                });
                var hashObject = {};
                for (var _i = 0, _Object$keys = Object.keys(hash); _i < _Object$keys.length; _i++) {
                  var i = _Object$keys[_i];
                  hashObject[decodeURIComponent(hash[i][0])] = decodeURIComponent(hash[i][1]);
                }
                return hashObject;
              };
              if (!document.location.hash.includes("token_type=Bearer")) {
                _context2.next = 18;
                break;
              }
              hashObject = parse_query(document.location.hash);
              if (!(!this.options.ignore_state && this._state !== hashObject["state"])) {
                _context2.next = 8;
                break;
              }
              console.warn('"state" parameter doesn\'t match');
              return _context2.abrupt("return", false);
            case 8:
              this.token = "".concat(hashObject["token_type"], " ").concat(hashObject["access_token"]);
              _context2.next = 11;
              return this._load_user(this.token);
            case 11:
              if (!(hashObject["id_token"] && this.options.scope.includes('openid'))) {
                _context2.next = 17;
                break;
              }
              this.id_token = hashObject["id_token"];
              if (!this.options.decode_id_token) {
                _context2.next = 17;
                break;
              }
              _context2.next = 16;
              return this.decode_id_token();
            case 16:
              this.decoded_id_token = _context2.sent;
            case 17:
              return _context2.abrupt("return", true);
            case 18:
              return _context2.abrupt("return", false);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _oauth() {
        return _oauth2.apply(this, arguments);
      }
      return _oauth;
    }()
    /**
     * Returns state for OAuth
     * @return {string} state
     */
  }, {
    key: "_state",
    get: function get() {
      var state_storage_key = "".concat(this.options.session_name, "_state");
      var state;
      if (localStorage.getItem(state_storage_key)) {
        state = localStorage.getItem(state_storage_key);
      } else {
        state = Math.floor(Math.random() * 10000000).toString();
        localStorage.setItem(state_storage_key, state);
      }
      return state;
    }

    /**
     * Handles rate limit if enabled in the constructor options.
     * @param {object} err - The error object returned from he API
     * @param {function} callback - the method that will be executed right after rate limit ends
     * @return {Promise} result of resent request
     */
  }, {
    key: "handle_rate_limit",
    value: function handle_rate_limit(err, callback) {
      var seconds = err["@error"]["@rateLimit"]["Retry-After"] || 1;
      console.warn("Too much requests. Retry after ".concat(seconds, "s"));
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          callback().then(resolve).catch(reject);
        }, seconds * 1000);
      });
    }

    /**
     * Handles internal server errors if enabled in the constructor options.
     * @param {object} err - The error object returned from he API
     * @param {function} callback - the method that will be executed after 500ms
     * @return {Promise} result of resent request
     */
  }, {
    key: "handle_internal_server_error",
    value: function handle_internal_server_error(err, callback) {
      console.warn("Internal server error. Retrying...", err);
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          callback().then(resolve).catch(reject);
        }, 500);
      });
    }

    /**
     * Loads the user by the Bearer token, sets session expiration time
     * @param {string} token - Bearer token
     * @param {number} _attempt - attempt number (used for retries limitation)
     */
  }, {
    key: "_load_user",
    value: function () {
      var _load_user2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(token) {
        var _this = this;
        var uses_token,
          _attempt,
          response,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              uses_token = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : false;
              _attempt = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : 1;
              _context5.prev = 2;
              this.uses_token = uses_token;
              _context5.next = 6;
              return this.call_api('get', "/v4/oauth/access-token", null, true, {}, token);
            case 6:
              response = _context5.sent;
              history.pushState("", document.title, "".concat(window.location.pathname).concat(window.location.search));
              _context5.next = 10;
              return this.set_user({
                id: response["scope_details"][0]["voip_id"],
                token: token,
                expiration: response["expires_at"] ? response["expires_at"] * 1000 : null
              });
            case 10:
              _context5.next = 21;
              break;
            case 12:
              _context5.prev = 12;
              _context5.t0 = _context5["catch"](2);
              if (!(_context5.t0.status === 429 && this.options.handle_rate_limit)) {
                _context5.next = 17;
                break;
              }
              _context5.next = 17;
              return this.handle_rate_limit(_context5.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      _context3.next = 2;
                      return _this._load_user(token, _attempt);
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              })));
            case 17:
              if (!(_context5.t0.status >= 500 && _context5.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context5.next = 20;
                break;
              }
              _context5.next = 20;
              return this.handle_internal_server_error(_context5.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      _attempt++;
                      _context4.next = 3;
                      return _this._load_user(token, _attempt);
                    case 3:
                      return _context4.abrupt("return", _context4.sent);
                    case 4:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              })));
            case 20:
              throw _context5.t0;
            case 21:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[2, 12]]);
      }));
      function _load_user(_x) {
        return _load_user2.apply(this, arguments);
      }
      return _load_user;
    }()
    /**
     * Signs out the authenticated user
     */
  }, {
    key: "sign_out",
    value: function () {
      var _sign_out = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var session_expired,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              session_expired = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
              if (this.listeners["logging-out"]) this.listeners["logging-out"]();
              _context6.prev = 2;
              if (!(this.options.id_token_sign_out && this.options.scope.includes('openid') && this.id_token)) {
                _context6.next = 9;
                break;
              }
              _context6.next = 6;
              return this.delete_access_token();
            case 6:
              this.openid_endsession(session_expired);
              _context6.next = 12;
              break;
            case 9:
              _context6.next = 11;
              return this.delete_access_token();
            case 11:
              this.post_sign_out(session_expired);
            case 12:
              _context6.next = 17;
              break;
            case 14:
              _context6.prev = 14;
              _context6.t0 = _context6["catch"](2);
              console.log(_context6.t0);
            case 17:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[2, 14]]);
      }));
      function sign_out() {
        return _sign_out.apply(this, arguments);
      }
      return sign_out;
    }()
    /*
    * Cleans cache and calls logged-out callback if provided
    */
  }, {
    key: "post_sign_out",
    value: function post_sign_out(session_expired) {
      this.id_token = null;
      this.decoded_id_token = null;
      this.user = null;
      this.reset_cache();
      this._removeItem(this.options.session_name);
      if (this.listeners["logged-out"] && !session_expired) this.listeners["logged-out"]();
    }

    /**
     * Goes to openid endsession route and comes back to project root route
     */
  }, {
    key: "openid_endsession",
    value: function openid_endsession(session_expired) {
      var redirect = "".concat(document.location.protocol, "//").concat(document.location.host);
      var uri = "".concat(this.options.oauth_api_url, "/connect/endsession?id_token_hint=").concat(encodeURIComponent(this.id_token), "&post_logout_redirect_uri=").concat(encodeURIComponent(redirect));
      this.post_sign_out(session_expired);
      window.location.assign(uri);
      return true;
    }

    /**
     * Deletes current access token
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "delete_access_token",
    value: function () {
      var _delete_access_token = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this2 = this;
        var _attempt,
          url,
          headers,
          _args9 = arguments;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _attempt = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : 1;
              _context9.prev = 1;
              if (!this.uses_token) {
                _context9.next = 4;
                break;
              }
              return _context9.abrupt("return", true);
            case 4:
              url = this._phoenix_url("/v4/oauth/access-token", true);
              headers = this._phoenix_auth_headers();
              _context9.next = 8;
              return this.fetch_response(url, {
                method: "DELETE",
                headers: headers
              });
            case 8:
              return _context9.abrupt("return", _context9.sent);
            case 11:
              _context9.prev = 11;
              _context9.t0 = _context9["catch"](1);
              if (!(_context9.t0.status === 401)) {
                _context9.next = 15;
                break;
              }
              return _context9.abrupt("return", null);
            case 15:
              if (!(_context9.t0.status === 429 && this.options.handle_rate_limit)) {
                _context9.next = 19;
                break;
              }
              _context9.next = 18;
              return this.handle_rate_limit(_context9.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
                return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                  while (1) switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return _this2.delete_access_token(_attempt);
                    case 2:
                      return _context7.abrupt("return", _context7.sent);
                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }, _callee7);
              })));
            case 18:
              return _context9.abrupt("return", _context9.sent);
            case 19:
              if (!(_context9.t0.status >= 500 && _context9.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context9.next = 22;
                break;
              }
              _context9.next = 22;
              return this.handle_internal_server_error(_context9.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
                return _regeneratorRuntime().wrap(function _callee8$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      _attempt++;
                      _context8.next = 3;
                      return _this2.delete_access_token(_attempt);
                    case 3:
                      return _context8.abrupt("return", _context8.sent);
                    case 4:
                    case "end":
                      return _context8.stop();
                  }
                }, _callee8);
              })));
            case 22:
              if (this.listeners["error"]) this.listeners["error"](_context9.t0);
              throw _context9.t0;
            case 24:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this, [[1, 11]]);
      }));
      function delete_access_token() {
        return _delete_access_token.apply(this, arguments);
      }
      return delete_access_token;
    }()
  }, {
    key: "on",
    value: function on(eventname, callback) {
      this.listeners[eventname] = callback;
    }

    /**
     * Signs out the user with expired session
     */
  }, {
    key: "handle_expired_session",
    value: function () {
      var _handle_expired_session = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.sign_out(true);
            case 2:
              if (this.listeners["session-expired"]) this.listeners["session-expired"]();
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function handle_expired_session() {
        return _handle_expired_session.apply(this, arguments);
      }
      return handle_expired_session;
    }()
    /**
     * Performs check if user expiration date is passed
     */
  }, {
    key: "_session_expired",
    value: function _session_expired() {
      return this.expiration_timeout - Date.now() - 10000 < 0;
    }

    /**
     * Sets the user for the session, sets session expiration time
     * @param {object} user - object with user id, token and expiration time
     */
  }, {
    key: "set_user",
    value: function () {
      var _set_user = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(user) {
        var max_timeout, timeout;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              this.user = user;
              if (!user["expiration"]) {
                _context11.next = 18;
                break;
              }
              this.expiration_timeout = user["expiration"];
              if (!this._session_expired()) {
                _context11.next = 8;
                break;
              }
              _context11.next = 6;
              return this.handle_expired_session();
            case 6:
              _context11.next = 18;
              break;
            case 8:
              this._setItem(this.options.session_name, JSON.stringify(user, null, 2));
              max_timeout = 2147483647;
              timeout = user["expiration"] - Date.now() - 10000;
              if (timeout > max_timeout) {
                timeout = max_timeout;
              }
              _context11.t0 = setTimeout;
              _context11.next = 15;
              return this.handle_expired_session.bind(this);
            case 15:
              _context11.t1 = _context11.sent;
              _context11.t2 = timeout;
              (0, _context11.t0)(_context11.t1, _context11.t2);
            case 18:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function set_user(_x2) {
        return _set_user.apply(this, arguments);
      }
      return set_user;
    }()
    /**
     * Returns sign in page URL for the user
     * @return {string} A _get_auth_link method result.
     */
  }, {
    key: "oauth_url",
    get: function get() {
      return this._get_oauth_url("", true);
    }

    /**
     * Generates sign in page URL for the user.
     * @param {string} redirect_path - path to the specific redirect page
     * @param {boolean} is_token - specifies is response_type in the uri should be
     * token (if true) or code  (if false)
     * @return {string} sign in uri
     */
  }, {
    key: "_get_oauth_url",
    value: function _get_oauth_url(redirect_path, is_token) {
      var redirect = "".concat(document.location.protocol, "//").concat(document.location.host).concat(redirect_path);
      return "".concat(this.options.accounts_url, "/?client_id=").concat(this.options.client_id, "&response_type=").concat(is_token ? "token" : "code").concat(this.options.scope.includes("openid") ? encodeURIComponent(" id_token") : "", "&scope=").concat(encodeURIComponent(this.options.scope.join(" ")), "&redirect_uri=").concat(encodeURIComponent(redirect)).concat(this.options.ignore_state ? '' : '&state=' + this._state);
    }

    /**
     * Generates base url for the api calls
     * @param {string} uri - path to specific resource
     * @param {boolean} global - generates URL with "/v4/account/:account_id", true - generates url with "/v4" only
     * @return {string} generated url
     */
  }, {
    key: "_phoenix_url",
    value: function _phoenix_url(uri) {
      var global = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var url = this.options.phoenix_url;
      if (!global) {
        url += "/v4/accounts/".concat(this.user["id"]);
      }
      return "".concat(url).concat(uri);
    }

    /**
     * Generates headers for API calls.
     * @param {string} token - user token (required if user is not set)
     * @return {object} headers object
     */
  }, {
    key: "_phoenix_auth_headers",
    value: function _phoenix_auth_headers() {
      var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      var token_provided = token && token.length;
      return this.user && this.user["token"] || token_provided ? {
        Authorization: token_provided ? token : this.user["token"]
      } : {};
    }

    /**
     * Gets all items specified in the uri.
     * @param {string} uri - target resource uri
     * @param {boolean} global - generates URL with "/v4/account/:account_id", true - generates url with "/v4" only
     * @return {object} object containing all requested items
     */
  }, {
    key: "get_list_all",
    value: function () {
      var _get_list_all = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(uri) {
        var global,
          all,
          res,
          _args12 = arguments;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              global = _args12.length > 1 && _args12[1] !== undefined ? _args12[1] : false;
              all = [];
            case 2:
              _context12.next = 4;
              return this.get_list(uri, 500, res ? res["offset"] + res["limit"] : 0, global);
            case 4:
              res = _context12.sent;
              all = all.concat(res["items"]);
            case 6:
              if (res["total"] > all.length && res["items"].length) {
                _context12.next = 2;
                break;
              }
            case 7:
              return _context12.abrupt("return", {
                items: all,
                offset: 0,
                total: all.length,
                limit: all.length
              });
            case 8:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function get_list_all(_x3) {
        return _get_list_all.apply(this, arguments);
      }
      return get_list_all;
    }()
    /**
     * Gets items specified in the uri.
     * @param {string} uri - target resource uri
     * @param {number} limit - API limit
     * @param {number} offset - API offset
     * @param {boolean} global - generates URL with "/v4/account/:account_id", true - generates url with "/v4" only
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} object containing requested items
     */
  }, {
    key: "get_list",
    value: function () {
      var _get_list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(uri) {
        var _this3 = this;
        var limit,
          offset,
          global,
          _attempt,
          r,
          _args15 = arguments;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              limit = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : 25;
              offset = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : 0;
              global = _args15.length > 3 && _args15[3] !== undefined ? _args15[3] : false;
              _attempt = _args15.length > 4 && _args15[4] !== undefined ? _args15[4] : 1;
              _context15.prev = 4;
              if (limit && _attempt === 1) {
                uri += uri.includes("?") ? "&" : "?";
                uri += "limit=" + limit;
                if (offset) uri += "&offset=" + offset;
              }
              _context15.next = 8;
              return this.call_api('get', global ? '/v4' + uri : uri, null, global);
            case 8:
              r = _context15.sent;
              return _context15.abrupt("return", {
                items: r["items"],
                offset: r["offset"],
                total: r["total"],
                limit: r["limit"]
              });
            case 12:
              _context15.prev = 12;
              _context15.t0 = _context15["catch"](4);
              if (!(_context15.t0.status === 429 && this.options.handle_rate_limit)) {
                _context15.next = 18;
                break;
              }
              _context15.next = 17;
              return this.handle_rate_limit(_context15.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
                return _regeneratorRuntime().wrap(function _callee13$(_context13) {
                  while (1) switch (_context13.prev = _context13.next) {
                    case 0:
                      _context13.next = 2;
                      return _this3.get_list(uri, limit, offset, global, _attempt);
                    case 2:
                      return _context13.abrupt("return", _context13.sent);
                    case 3:
                    case "end":
                      return _context13.stop();
                  }
                }, _callee13);
              })));
            case 17:
              return _context15.abrupt("return", _context15.sent);
            case 18:
              if (!(_context15.t0.status >= 500 && _context15.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context15.next = 21;
                break;
              }
              _context15.next = 21;
              return this.handle_internal_server_error(_context15.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
                return _regeneratorRuntime().wrap(function _callee14$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      _attempt++;
                      _context14.next = 3;
                      return _this3.get_list(uri, limit, offset, global, _attempt);
                    case 3:
                      return _context14.abrupt("return", _context14.sent);
                    case 4:
                    case "end":
                      return _context14.stop();
                  }
                }, _callee14);
              })));
            case 21:
              throw _context15.t0;
            case 22:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this, [[4, 12]]);
      }));
      function get_list(_x4) {
        return _get_list.apply(this, arguments);
      }
      return get_list;
    }()
    /**
     * Gets the item specified in the uri
     * @param {string} uri - target resource uri
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "get_item",
    value: function () {
      var _get_item = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(uri) {
        var _this4 = this;
        var _attempt,
          item,
          _args18 = arguments;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _attempt = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : 1;
              _context18.prev = 1;
              _context18.next = 4;
              return this.call_api('get', uri);
            case 4:
              item = _context18.sent;
              return _context18.abrupt("return", item);
            case 8:
              _context18.prev = 8;
              _context18.t0 = _context18["catch"](1);
              if (!(_context18.t0.status === 429 && this.options.handle_rate_limit)) {
                _context18.next = 14;
                break;
              }
              _context18.next = 13;
              return this.handle_rate_limit(_context18.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
                return _regeneratorRuntime().wrap(function _callee16$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      _context16.next = 2;
                      return _this4.get_item(uri, _attempt);
                    case 2:
                      return _context16.abrupt("return", _context16.sent);
                    case 3:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              })));
            case 13:
              return _context18.abrupt("return", _context18.sent);
            case 14:
              if (!(_context18.t0.status >= 500 && _context18.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context18.next = 17;
                break;
              }
              _context18.next = 17;
              return this.handle_internal_server_error(_context18.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
                return _regeneratorRuntime().wrap(function _callee17$(_context17) {
                  while (1) switch (_context17.prev = _context17.next) {
                    case 0:
                      _attempt++;
                      _context17.next = 3;
                      return _this4.get_item(uri, _attempt);
                    case 3:
                      return _context17.abrupt("return", _context17.sent);
                    case 4:
                    case "end":
                      return _context17.stop();
                  }
                }, _callee17);
              })));
            case 17:
              throw _context18.t0;
            case 18:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this, [[1, 8]]);
      }));
      function get_item(_x5) {
        return _get_item.apply(this, arguments);
      }
      return get_item;
    }()
    /**
     * Deletes the item specified in the uri
     * @param {string} uri - target resource uri
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "delete_item",
    value: function () {
      var _delete_item = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(uri) {
        var _this5 = this;
        var _attempt,
          item,
          _args21 = arguments;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _attempt = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : 1;
              _context21.prev = 1;
              _context21.next = 4;
              return this.call_api('delete', uri);
            case 4:
              item = _context21.sent;
              return _context21.abrupt("return", item);
            case 8:
              _context21.prev = 8;
              _context21.t0 = _context21["catch"](1);
              if (!(_context21.t0.status === 429 && this.options.handle_rate_limit)) {
                _context21.next = 14;
                break;
              }
              _context21.next = 13;
              return this.handle_rate_limit(_context21.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
                return _regeneratorRuntime().wrap(function _callee19$(_context19) {
                  while (1) switch (_context19.prev = _context19.next) {
                    case 0:
                      _context19.next = 2;
                      return _this5.delete_item(uri, _attempt);
                    case 2:
                      return _context19.abrupt("return", _context19.sent);
                    case 3:
                    case "end":
                      return _context19.stop();
                  }
                }, _callee19);
              })));
            case 13:
              return _context21.abrupt("return", _context21.sent);
            case 14:
              if (!(_context21.t0.status >= 500 && _context21.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context21.next = 17;
                break;
              }
              _context21.next = 17;
              return this.handle_internal_server_error(_context21.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
                return _regeneratorRuntime().wrap(function _callee20$(_context20) {
                  while (1) switch (_context20.prev = _context20.next) {
                    case 0:
                      _attempt++;
                      _context20.next = 3;
                      return _this5.delete_item(uri, _attempt);
                    case 3:
                      return _context20.abrupt("return", _context20.sent);
                    case 4:
                    case "end":
                      return _context20.stop();
                  }
                }, _callee20);
              })));
            case 17:
              throw _context21.t0;
            case 18:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this, [[1, 8]]);
      }));
      function delete_item(_x6) {
        return _delete_item.apply(this, arguments);
      }
      return delete_item;
    }()
    /**
     * Downloads the item specified in the uri
     * @param {string} uri - target resource uri
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "download_item",
    value: function () {
      var _download_item = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(uri) {
        var _this6 = this;
        var _attempt,
          item,
          response,
          _args24 = arguments;
        return _regeneratorRuntime().wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _attempt = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : 1;
              _context24.prev = 1;
              _context24.next = 4;
              return this.call_api('get', uri + (uri.includes('?') ? '' : '?get_temp_url=1'), null, false);
            case 4:
              item = _context24.sent;
              _context24.next = 7;
              return fetch(item.url);
            case 7:
              response = _context24.sent;
              _context24.next = 10;
              return response.blob();
            case 10:
              return _context24.abrupt("return", _context24.sent);
            case 13:
              _context24.prev = 13;
              _context24.t0 = _context24["catch"](1);
              if (!(_context24.t0.status === 429 && this.options.handle_rate_limit)) {
                _context24.next = 19;
                break;
              }
              _context24.next = 18;
              return this.handle_rate_limit(_context24.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
                return _regeneratorRuntime().wrap(function _callee22$(_context22) {
                  while (1) switch (_context22.prev = _context22.next) {
                    case 0:
                      _context22.next = 2;
                      return _this6.download_item(uri, _attempt);
                    case 2:
                      return _context22.abrupt("return", _context22.sent);
                    case 3:
                    case "end":
                      return _context22.stop();
                  }
                }, _callee22);
              })));
            case 18:
              return _context24.abrupt("return", _context24.sent);
            case 19:
              if (!(_context24.t0.status >= 500 && _context24.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context24.next = 22;
                break;
              }
              _context24.next = 22;
              return this.handle_internal_server_error(_context24.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23() {
                return _regeneratorRuntime().wrap(function _callee23$(_context23) {
                  while (1) switch (_context23.prev = _context23.next) {
                    case 0:
                      _attempt++;
                      _context23.next = 3;
                      return _this6.download_item(uri, _attempt);
                    case 3:
                      return _context23.abrupt("return", _context23.sent);
                    case 4:
                    case "end":
                      return _context23.stop();
                  }
                }, _callee23);
              })));
            case 22:
              throw _context24.t0;
            case 23:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this, [[1, 13]]);
      }));
      function download_item(_x7) {
        return _download_item.apply(this, arguments);
      }
      return download_item;
    }()
    /**
     * Sends PUT request to update the item specified in the uri
     * @param {string} uri - target resource uri
     * @param {object} data - data that should be updated
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "replace_item",
    value: function () {
      var _replace_item = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee27(uri, data) {
        var _this7 = this;
        var _attempt,
          item,
          _args27 = arguments;
        return _regeneratorRuntime().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _attempt = _args27.length > 2 && _args27[2] !== undefined ? _args27[2] : 1;
              _context27.prev = 1;
              _context27.next = 4;
              return this.call_api('put', uri, data);
            case 4:
              item = _context27.sent;
              return _context27.abrupt("return", item);
            case 8:
              _context27.prev = 8;
              _context27.t0 = _context27["catch"](1);
              if (!(_context27.t0.status === 429 && this.options.handle_rate_limit)) {
                _context27.next = 14;
                break;
              }
              _context27.next = 13;
              return this.handle_rate_limit(_context27.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25() {
                return _regeneratorRuntime().wrap(function _callee25$(_context25) {
                  while (1) switch (_context25.prev = _context25.next) {
                    case 0:
                      _context25.next = 2;
                      return _this7.replace_item(uri, data, _attempt);
                    case 2:
                      return _context25.abrupt("return", _context25.sent);
                    case 3:
                    case "end":
                      return _context25.stop();
                  }
                }, _callee25);
              })));
            case 13:
              return _context27.abrupt("return", _context27.sent);
            case 14:
              if (!(_context27.t0.status >= 500 && _context27.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context27.next = 17;
                break;
              }
              _context27.next = 17;
              return this.handle_internal_server_error(_context27.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee26() {
                return _regeneratorRuntime().wrap(function _callee26$(_context26) {
                  while (1) switch (_context26.prev = _context26.next) {
                    case 0:
                      _attempt++;
                      _context26.next = 3;
                      return _this7.replace_item(uri, data, _attempt);
                    case 3:
                      return _context26.abrupt("return", _context26.sent);
                    case 4:
                    case "end":
                      return _context26.stop();
                  }
                }, _callee26);
              })));
            case 17:
              throw _context27.t0;
            case 18:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this, [[1, 8]]);
      }));
      function replace_item(_x8, _x9) {
        return _replace_item.apply(this, arguments);
      }
      return replace_item;
    }()
    /**
     * Sends PATCH request to update the item specified in the uri
     * @param {string} uri - target resource uri
     * @param {object} data - data that should be updated
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "patch_item",
    value: function () {
      var _patch_item = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee30(uri, data) {
        var _this8 = this;
        var _attempt,
          item,
          _args30 = arguments;
        return _regeneratorRuntime().wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _attempt = _args30.length > 2 && _args30[2] !== undefined ? _args30[2] : 1;
              _context30.prev = 1;
              _context30.next = 4;
              return this.call_api('patch', uri, data);
            case 4:
              item = _context30.sent;
              return _context30.abrupt("return", item);
            case 8:
              _context30.prev = 8;
              _context30.t0 = _context30["catch"](1);
              if (!(_context30.t0.status === 429 && this.options.handle_rate_limit)) {
                _context30.next = 14;
                break;
              }
              _context30.next = 13;
              return this.handle_rate_limit(_context30.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee28() {
                return _regeneratorRuntime().wrap(function _callee28$(_context28) {
                  while (1) switch (_context28.prev = _context28.next) {
                    case 0:
                      _context28.next = 2;
                      return _this8.patch_item(uri, data, _attempt);
                    case 2:
                      return _context28.abrupt("return", _context28.sent);
                    case 3:
                    case "end":
                      return _context28.stop();
                  }
                }, _callee28);
              })));
            case 13:
              return _context30.abrupt("return", _context30.sent);
            case 14:
              if (!(_context30.t0.status >= 500 && _context30.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context30.next = 17;
                break;
              }
              _context30.next = 17;
              return this.handle_internal_server_error(_context30.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee29() {
                return _regeneratorRuntime().wrap(function _callee29$(_context29) {
                  while (1) switch (_context29.prev = _context29.next) {
                    case 0:
                      _attempt++;
                      _context29.next = 3;
                      return _this8.patch_item(uri, data, _attempt);
                    case 3:
                      return _context29.abrupt("return", _context29.sent);
                    case 4:
                    case "end":
                      return _context29.stop();
                  }
                }, _callee29);
              })));
            case 17:
              throw _context30.t0;
            case 18:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this, [[1, 8]]);
      }));
      function patch_item(_x10, _x11) {
        return _patch_item.apply(this, arguments);
      }
      return patch_item;
    }()
    /**
     * Created the resource specified in the uri
     * @param {string} uri - target resource uri
     * @param {object} data - data that should be created
     * @param {number} _attempt - attempt number (used for retries limitation)
     * @return {object} response object.
     */
  }, {
    key: "create_item",
    value: function () {
      var _create_item = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee33(uri, data) {
        var _this9 = this;
        var _attempt,
          item,
          _args33 = arguments;
        return _regeneratorRuntime().wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _attempt = _args33.length > 2 && _args33[2] !== undefined ? _args33[2] : 1;
              _context33.prev = 1;
              _context33.next = 4;
              return this.call_api('post', uri, data);
            case 4:
              item = _context33.sent;
              return _context33.abrupt("return", item);
            case 8:
              _context33.prev = 8;
              _context33.t0 = _context33["catch"](1);
              if (!(_context33.t0.status === 429 && this.options.handle_rate_limit)) {
                _context33.next = 14;
                break;
              }
              _context33.next = 13;
              return this.handle_rate_limit(_context33.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee31() {
                return _regeneratorRuntime().wrap(function _callee31$(_context31) {
                  while (1) switch (_context31.prev = _context31.next) {
                    case 0:
                      _context31.next = 2;
                      return _this9.create_item(uri, data, _attempt);
                    case 2:
                      return _context31.abrupt("return", _context31.sent);
                    case 3:
                    case "end":
                      return _context31.stop();
                  }
                }, _callee31);
              })));
            case 13:
              return _context33.abrupt("return", _context33.sent);
            case 14:
              if (!(_context33.t0.status >= 500 && _context33.t0.status <= 599 && this.options.handle_server_error && _attempt <= this.options.handle_server_error)) {
                _context33.next = 17;
                break;
              }
              _context33.next = 17;
              return this.handle_internal_server_error(_context33.t0, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee32() {
                return _regeneratorRuntime().wrap(function _callee32$(_context32) {
                  while (1) switch (_context32.prev = _context32.next) {
                    case 0:
                      _attempt++;
                      _context32.next = 3;
                      return _this9.create_item(uri, data, _attempt);
                    case 3:
                      return _context32.abrupt("return", _context32.sent);
                    case 4:
                    case "end":
                      return _context32.stop();
                  }
                }, _callee32);
              })));
            case 17:
              throw _context33.t0;
            case 18:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this, [[1, 8]]);
      }));
      function create_item(_x12, _x13) {
        return _create_item.apply(this, arguments);
      }
      return create_item;
    }()
    /**
     * Decodes id token, validates the signature
     * @return {object} token payload or null.
     */
  }, {
    key: "decode_id_token",
    value: function () {
      var _decode_id_token = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee34() {
        var tokenparts, header, payload, configuration, keys, alg, key;
        return _regeneratorRuntime().wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (this.id_token) {
                _context34.next = 3;
                break;
              }
              console.warn('id_token not found');
              return _context34.abrupt("return", null);
            case 3:
              _context34.prev = 3;
              tokenparts = this.id_token.split('.');
              header = JSON.parse(atob(tokenparts[0]));
              payload = JSON.parse(atob(tokenparts[1]));
              _context34.next = 9;
              return this.fetch_response("".concat(payload.iss, "/.well-known/openid-configuration/"));
            case 9:
              configuration = _context34.sent;
              _context34.next = 12;
              return this.fetch_response(configuration.keys);
            case 12:
              keys = _context34.sent;
              alg = header.alg;
              key = keys.data.keys.find(function (x) {
                return x.alg === alg;
              });
              if (!key) {
                _context34.next = 22;
                break;
              }
              if (jws.verify(this.id_token, alg, jwkToPem(key))) {
                _context34.next = 19;
                break;
              }
              console.warn('Your id_token could not be validated.');
              return _context34.abrupt("return", null);
            case 19:
              return _context34.abrupt("return", payload);
            case 22:
              console.warn('Matching key could not be found.');
              return _context34.abrupt("return", null);
            case 24:
              _context34.next = 30;
              break;
            case 26:
              _context34.prev = 26;
              _context34.t0 = _context34["catch"](3);
              console.warn('Error decoding your ID token.');
              return _context34.abrupt("return", null);
            case 30:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this, [[3, 26]]);
      }));
      function decode_id_token() {
        return _decode_id_token.apply(this, arguments);
      }
      return decode_id_token;
    }()
    /**
     * Method for making custom API call
     * @param method
     * @param uri
     * @param body
     * @param is_uri_global
     * @param options
     * @param token
     * @return {Promise<*>}
     */
  }, {
    key: "call_api",
    value: function () {
      var _call_api = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee35(method, uri) {
        var body,
          is_uri_global,
          options,
          token,
          url,
          headers,
          options_a,
          _args35 = arguments;
        return _regeneratorRuntime().wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              body = _args35.length > 2 && _args35[2] !== undefined ? _args35[2] : null;
              is_uri_global = _args35.length > 3 && _args35[3] !== undefined ? _args35[3] : false;
              options = _args35.length > 4 && _args35[4] !== undefined ? _args35[4] : {};
              token = _args35.length > 5 && _args35[5] !== undefined ? _args35[5] : '';
              _context35.prev = 4;
              url = this._phoenix_url(uri, is_uri_global);
              headers = token.length ? this._phoenix_auth_headers(token) : this._phoenix_auth_headers();
              options_a = _objectSpread({
                method: method.toUpperCase(),
                headers: headers
              }, options);
              if (body) {
                options_a.body = JSON.stringify(body);
              }
              _context35.next = 11;
              return this.fetch_response(url, options_a);
            case 11:
              return _context35.abrupt("return", _context35.sent);
            case 14:
              _context35.prev = 14;
              _context35.t0 = _context35["catch"](4);
              if (!(_context35.t0.status === 401 && this._session_expired())) {
                _context35.next = 20;
                break;
              }
              _context35.next = 19;
              return this.handle_expired_session();
            case 19:
              return _context35.abrupt("return", {});
            case 20:
              if (this.listeners["error"]) this.listeners["error"](_context35.t0);
              throw _context35.t0;
            case 22:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this, [[4, 14]]);
      }));
      function call_api(_x14, _x15) {
        return _call_api.apply(this, arguments);
      }
      return call_api;
    }()
  }, {
    key: "fetch_response",
    value: function () {
      var _fetch_response = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee36(url, options) {
        var api_response, response;
        return _regeneratorRuntime().wrap(function _callee36$(_context36) {
          while (1) switch (_context36.prev = _context36.next) {
            case 0:
              _context36.next = 2;
              return fetch(url, options);
            case 2:
              response = _context36.sent;
              if (!(options.responseType === 'blob')) {
                _context36.next = 9;
                break;
              }
              _context36.next = 6;
              return response.blob();
            case 6:
              api_response = _context36.sent;
              _context36.next = 12;
              break;
            case 9:
              _context36.next = 11;
              return response.json();
            case 11:
              api_response = _context36.sent;
            case 12:
              if (!response.ok) {
                _context36.next = 14;
                break;
              }
              return _context36.abrupt("return", api_response);
            case 14:
              throw _objectSpread(_objectSpread({}, api_response), {}, {
                status: response.status
              });
            case 15:
            case "end":
              return _context36.stop();
          }
        }, _callee36);
      }));
      function fetch_response(_x16, _x17) {
        return _fetch_response.apply(this, arguments);
      }
      return fetch_response;
    }()
    /**
     * Method for clearing all cache the package made
     */
  }, {
    key: "reset_cache",
    value:
    /**
     * Method for clearing all cache the package made
     */
    function reset_cache() {
      var cache = this._getItem(this.cache_keys);
      if (cache) {
        cache = JSON.parse(cache);
        var _iterator = _createForOfIteratorHelper(cache),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var c = _step.value;
            this._removeItem(c);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return true;
    }

    /**
     * Method for storing in session/local storage based on this.options.session_scope value
     * @param {string} key
     * @param {string} value
     * @return {boolean} true
     */
  }, {
    key: "_setItem",
    value: function _setItem(key, value) {
      var keys = this._getItem(this.cache_keys);
      keys = keys ? JSON.parse(keys) : [];
      keys.push(key);
      keys = JSON.stringify(_toConsumableArray(new Set(keys)));
      if (this.options.session_scope === 'tab') {
        sessionStorage.setItem(key, value);
        sessionStorage.setItem(this.cache_keys, keys);
      } else {
        localStorage.setItem(key, value);
        localStorage.setItem(this.cache_keys, keys);
      }
      return true;
    }

    /**
     * Method for retrieving from session/local storage based on this.options.session_scope value
     * @param {string} key
     * @return {string} retrieved value
     */
  }, {
    key: "_getItem",
    value: function _getItem(key) {
      if (this.options.session_scope === 'tab') {
        return sessionStorage.getItem(key);
      }
      return localStorage.getItem(key);
    }

    /**
     * Method for removing from session/local storage based on this.options.session_scope value
     * @param {string} key
     * @return {boolean} true
     */
  }, {
    key: "_removeItem",
    value: function _removeItem(key) {
      if (this.options.session_scope === 'tab') {
        sessionStorage.removeItem(key);
      } else {
        localStorage.removeItem(key);
      }
      return true;
    }
  }]);
  return PhoenixApiClient;
}();
module.exports = PhoenixApiClient;